/**
 * ORM for User
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.1.13}
 */
export class UserModel {
    constructor(payload) {
        Object.assign(this, payload);
    }
}
